var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpDeskIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11952",
    transform: "translate(-675 -475.175)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 340",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(675 475.175)",
    style: {
      fill: "#ffec6d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11953"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2837",
    transform: "translate(680 479.175)",
    style: {
      fill: "none"
    },
    d: "M0 0h20v20H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11955"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11954",
    transform: "translate(681.626 481.638)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5358",
    d: "M15.912 7.721a7.54 7.54 0 1 0-15.074.05A1.648 1.648 0 0 0 0 9.212v1.675a1.68 1.68 0 0 0 1.675 1.675h.837V7.453a5.862 5.862 0 1 1 11.724 0V13.4h-6.7v1.675h6.7a1.68 1.68 0 0 0 1.676-1.675v-1.022A1.548 1.548 0 0 0 16.749 11V9.078a1.542 1.542 0 0 0-.837-1.357z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 341",
    cx: 0.5,
    cy: 1,
    rx: 0.5,
    ry: 1,
    transform: "translate(5.375 7.537)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    "data-name": "Ellipse 342",
    cx: 0.5,
    cy: 1,
    rx: 0.5,
    ry: 1,
    transform: "translate(10.375 7.537)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5359",
    d: "M13.399 6.724A5.058 5.058 0 0 0 3.367 7.912a6.762 6.762 0 0 0 4.07-4.933 6.731 6.731 0 0 0 5.962 3.745z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpDeskIcon);
export default __webpack_public_path__ + "static/media/help_desk_icon.55efdc4267682648e326833c9da559f1.svg";
export { ForwardRef as ReactComponent };